export default __webpack_public_path__ + "static/media/jessica.da228af3.jpg";